// 60s + pausa com aba oculta: a 15s o refetch integral da lista congelava
// contas grandes (re-render + GC constantes) e desperdiçava banda em background.
export const CHAT_LIST_AUTO_REFRESH_INTERVAL = 60000;

export const shouldRunChatListAutoRefresh = ({
  hasActiveFolders = false,
  hasAppliedFilters = false,
  isLoading = false,
  isRefreshing = false,
  isHidden = typeof document !== 'undefined' && document.hidden,
} = {}) => {
  return (
    !hasActiveFolders &&
    !hasAppliedFilters &&
    !isLoading &&
    !isRefreshing &&
    !isHidden
  );
};
